<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { openOverpanel } from '../../stores/overpanelControl';
  import { KEYCODES } from '../../utils/constants';
  import { trackEvent } from '../../utils/umami-events.js';
  
  let {
    headingText,
    headingLevel,
    description = undefined,
    inputPlaceHolder,
    buttonText,
    screenReaderSearchText,
    dataTestId = 'search-promo-lite',
    noHeading,
    closeCallback = () => {},
  } = $props();

  // remove html tags from heading content
  const headingTextContent =
    headingText && headingText.content ? headingText.content.replace(/<\/?[^>]+(>|$)/g, '') : undefined;

  let input = $state();
  let button = $state();

  const handleClick = (e) => {    
    openOverpanel('search', {
      closeCallback: () => {
        closeCallback();
        if (button && e.target === button) {
          button.focus();
        } else if (input) {
          input.focus();
        }
      },
    });

    trackEvent(`search-promo-lite-click`); 
  };

  const handleKeydown = (e) => {
    if (
      e.keyCode === KEYCODES.ESCAPE ||
      e.keyCode === KEYCODES.TAB ||
      e.keyCode === KEYCODES.ENTER ||
      e.keyCode === KEYCODES.SHIFT
    )
      return;
    handleClick(e);
  };
</script>

<div
  class="flex print:hidden justify-center text-center relative bg-blue-very-light"
  class:bg-transparent={noHeading}
  data-testid={dataTestId}
>
  <div
    class="flex items-center justify-center relative w-full max-w-120 md:w-full md:max-w-full md:min-h-56 lg:max-w-6xl"
    class:md:min-h-full={noHeading}
  >
    <div
      class="w-full justify-center max-w-150 px-4 py-6 md:py-16 lg:py-20 md:relative flex flex-col items-center"
      class:md:pt-4={noHeading}
      class:lg:pt-4={noHeading}
      class:md:pb-4={noHeading}
      class:lg:pb-4={noHeading}
    >
      {#if headingTextContent && !noHeading}
        {#if headingLevel === 'h1'}
          <h1
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy text-2xl md:text-3xl lg:text-4xl md:max-w-max lg:max-w-max"
            data-testid="search-promo-heading"
          >
            {@html headingTextContent}
          </h1>
        {:else if headingLevel === 'h2'}
          <h2
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy text-1.5xl md:text-2xl lg:text-3xl md:max-w-md lg:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingTextContent}
          </h2>
        {:else if headingLevel === 'h3'}
          <h3
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy text-1.5xl md:text-2xl lg:text-3xl md:max-w-md lg:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingTextContent}
          </h3>
        {:else}
          <h4
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy text-1.5xl md:text-2xl lg:text-3xl md:max-w-md lg:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingTextContent}
          </h4>
        {/if}
      {/if}
      {#if description}
        <div class="mb-4 md:mb-6 md:text-lg max-w-94">
          {@html description}
        </div>
      {/if}
      <div class="flex flex-row relative w-full md:max-w-full text-gray-gunmetal items-center md:z-10">
        <svg class="absolute top-4 left-4 w-4 h-4 fill-current" role="presentation">
          <use xlink:href="{SPRITESHEET_URL}magnifying-glass" />
        </svg>
        <button
          class="w-full rounded border border-gray-gunmetal bg-white py-2 pl-10 pr-4 leading-loose
            text-base text-gray-warm font-normal text-left placeholder-gray-warm cursor-text whitespace-nowrap
            overflow-hidden md:flex-2"
          aria-label={screenReaderSearchText}
          bind:this={input}
          onclick={handleClick}
          onkeydown={handleKeydown}
          data-testid="{dataTestId}-input"
        >
          {inputPlaceHolder}
        </button>
        <button
          class="flex-1 hidden md:block ml-3 rounded border-t border-blue-cerulean bg-blue-cerulean py-2 px-6
            text-center text-base leading-loose font-semibold text-white hover-hover:hover:bg-blue-darkish hover-hover:hover:border-blue-darkish
            active:bg-blue-navy active:border-blue-navy whitespace-nowrap"
          bind:this={button}
          onclick={handleClick}
          data-testid="{dataTestId}-button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  </div>
</div>
